module.exports = __webpack_public_path__ + "img/background.6d432bb1.jpg";